import React from 'react';
import { Box, Typography, Button, Chip } from '@curves/ui-base';
import { matchCycleOrderStatusColor } from '@Local/CyclePurchase/staticData';

/**
 * 循環訂單卡片
 * @param {object}   order          訂單資料（API 回應 CyclePurchaseOrderResponseModel）
 * @param {function} onEdit         點擊「變更訂購商品」
 * @param {function} onViewHistory  點擊「查看預約變更」
 */
const ORDER_NO_MAX_LENGTH = 15;

/** ISO datetime → "YYYY/MM/DD" */
const toDateStr = (iso) => (iso ? iso.slice(0, 10).replace(/-/g, '/') : '');

const CyclePurchaseOrderCard = ({ order, onEdit, onViewHistory }) => {
    const {
        cycleOrderNo,
        items = [],
        shippingDayText,
        saleAmount,
        nextShipDate,
        cycleOrderTypeText,
        statusColor,
    } = order;

    const chipColor = matchCycleOrderStatusColor(statusColor);

    const shortOrderNo =
        cycleOrderNo && cycleOrderNo.length > ORDER_NO_MAX_LENGTH
            ? `${cycleOrderNo.slice(0, ORDER_NO_MAX_LENGTH)}…`
            : cycleOrderNo;

    const saleAmountStr = `$${Number(saleAmount)?.toLocaleString()}`;
    const nextShipDateStr = toDateStr(nextShipDate);

    const handleEdit = () => onEdit?.(order);
    const handleViewHistory = () => onViewHistory?.(order);

    const itemRows = items.map((item, index) => (
        <Box key={item.productID ?? index} className="cp-order-item-row">
            <Typography className="cp-order-item-name">{item.productName}</Typography>
            <Typography className="cp-order-item-qty">x{item.quantity}</Typography>
        </Box>
    ));

    return (
        <Box className="cp-order-card">
            <Box className="cp-order-card-header">
                <Chip label={cycleOrderTypeText} color={chipColor} size="small" />
                <Typography className="cp-order-no">{shortOrderNo}</Typography>
            </Box>

            <Box className="cp-order-card-body">{itemRows}</Box>

            <Box className="cp-order-card-meta">
                <Box className="cp-order-meta-row">
                    <Typography className="cp-order-meta-label">出貨週期</Typography>
                    <Typography className="cp-order-meta-value">每月 <strong>{shippingDayText}</strong> 日</Typography>
                    <Box style={{ flex: 1 }} />
                    <Typography className="cp-order-meta-label">金額</Typography>
                    <Typography className="cp-order-meta-value">{saleAmountStr}</Typography>
                </Box>
                <Box className="cp-order-meta-divider" />
                <Box className="cp-order-meta-row cp-order-meta-row-ship">
                    <Typography className="cp-order-meta-label">預計下次出貨</Typography>
                    <Typography className="cp-order-next-date">{nextShipDateStr}</Typography>
                </Box>
            </Box>

            <Box className="cp-order-card-footer">
                <Button variant="contained" fullWidth onClick={handleEdit} className="cp-order-edit-btn">
                    變更訂購商品
                </Button>
                <Button variant="text" fullWidth onClick={handleViewHistory} className="cp-order-history-btn">
                    查看預約變更
                </Button>
            </Box>
        </Box>
    );
};

export default CyclePurchaseOrderCard;
